<template>
  <div class="bandWidth-detail-container">
    <div class="jc-page-header">
      <h1>
        <a href="javascript:void(0)" @click="go_back">
          <i class="el-icon-arrow-left"></i>
        </a>{{$t('bandWidth.bandWidthDetail')}}
        <small>{{data.bandwidthName | isStrEmpty}}</small>
      </h1>
    </div>
    <div class="jc-page-content">
      <el-tabs type="border-card">
        <!-- 基本信息  -->
        <div class="el-section">
          <div class="el-section-header">
            <h3 class="el-section-title">{{$t('merge.basicInfo')}}</h3>
          </div>
          <div class="el-section-content">
            <div class="base-info bandwidth-detail-box">
                <div class="item">{{$t('text.id')}}：{{data.bandwidthId | isStrEmpty}}</div>
                <div class="item">{{$t('bandWidth.name')}}：{{data.bandwidthName | isStrEmpty}}</div>
                <div class="item">{{$t('bandWidth.lineType')}}：{{data.lineTypeName | isStrEmpty}}</div>


                <div class="item">{{$t('bandWidth.chargeType')}}：{{data.chargeTypeName | isStrEmpty}}</div>
                <!--固定带宽-->
                <div class="item" v-if="data.chargeType == 'fixedBandwidth'">
                  {{$t('bandWidth.contractBandwidth')}}：<span v-if="data.bandwidth != 0">{{data.bandwidth}}</span> <span v-else>--</span>Mbps
                </div>
                <!--两种95峰值-->
                <div class="item" v-if="data.chargeType != 'fixedBandwidth'">
                  {{$t('bandWidth.minBandwidth')}}： <span v-if="data.bandwidth != 0">{{data.bandwidth}}</span> <span v-else>--</span> Mbps
                </div>
                <div class="item">{{$t('text.status')}}：{{data.statusName | isStrEmpty}}</div>


                <div class="item">{{$t('text.tags')}}：{{data.tagPairs | isStrEmpty}}
                  <el-button type="text"
                             @click="clickOperateTag">
                      <i class="el-icon-edit"></i>
                    </el-button></div>
            </div>
          </div>
        </div>
        <!-- 交换机信息 -->
        <div class="el-section">
          <div class="el-section-header">
            <h3 class="el-section-title">{{$t('bwTraffic.switchInfo')}}</h3>
          </div>
          <div class="el-section-content">
            <el-table :data="data.switchboard" style="width: 100%">
              <el-table-column prop="ip" :label="$t('bwTraffic.switchIP')"></el-table-column>
              <el-table-column prop="port" :label="$t('bwTraffic.port')"></el-table-column>
            </el-table>
          </div>
        </div>
        <!-- 关联的公网IP -->
        <div class="el-section">
          <div class="el-section-header">
            <h3 class="el-section-title">{{$t('bwTraffic.relateIP')}}</h3>
          </div>
          <div class="el-section-content">
            <el-table :data="data.relatedIp" stripe>
              <el-table-column prop="cidrAddr" :label="$t('ip.ipAddress')"></el-table-column>
              <el-table-column prop="lineType" :label="$t('bandWidth.lineType')">
                <template slot-scope="scope">
                  <span >{{data.lineTypeName | isStrEmpty}}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </el-tabs>
      <!--编辑标签-->
    <jcb-tag-edit :visible.sync="editTagDialogVisible"
                  :service-code="ServiceCodeConstant.CCS"
                  :region-id="TagRegionID"
                  :resource-ids="resourceId"
                  @complete="getBandWidthDetail">
    </jcb-tag-edit>
    </div>
  </div>
</template>

<script>
import { ServiceCodeConstant } from '@/common/Constants';

export default {
  data () {
    return {
      id: 0,
      idcId: 0,
      relatedIp: '',
      data: {
        lineType: '',
        bandwidth: ''
      },
      // 编辑标签组件是否显示
      editTagDialogVisible: false,
      resourceId: []
    };
  },
  computed: {
    ServiceCodeConstant: () => ServiceCodeConstant,
  },
  created () { },
  mounted () {
    this.id = this.$route.query.id;
    this.idcId = this.$route.query.idcId;
    this.getBandWidthDetail();
  },
  filters: {
    isStrEmpty (value) {
      if (value !== '') return value;
      return '--';
    }
  },
  methods: {
    clickOperateTag () {
      this.resourceId = [].concat([this.data.bandwidthId]);
      this.editTagDialogVisible = true;
    },
    getBandWidthDetail () {
      const params = {
        idc: this.idcId,
        bandwidthId: this.id
      };
      this.$api.getBandWidthDetail(params).then((res) => {
        if (res.errno === 10000 && res.errmsg === 'OK') {
          if (res.data && res.data.bandwidth) {
            this.data = res.data.bandwidth;
            // 格式化标签键值对
            const tagPairs = res.data.bandwidth.tags;
            this.data.tagPairs = '';
            if (tagPairs !== undefined) {
              if (tagPairs.length > 0) {
                tagPairs.forEach((tag) => {
                  this.data.tagPairs += `${tag.key}:${tag.value},`;
                });
                this.data.tagPairs = this.data.tagPairs.substring(0, this.data.tagPairs.length - 1);
              }
            }
            this.formatIpList();
          } else {
            this.data = null;
          }
        } else {
          this.$message.error(res.errmsg);
        }
      });
    },

    // 获取公网IP列表
    formatIpList () {
      this.data.ipList = [];
      if (this.data.relatedIp != '') {
        const ipArray = this.data.relatedIp.split(',');
        ipArray.forEach((element) => {
          this.data.ipList.push({
            ip: element,
            lineType: this.data.lineTypeName
          });
        });
      }
    },

    go_back () {
      this.$router.push('/bandwidth/list');
    }
  }
};
</script>
<style lang="scss">
.bandwidth-detail-box {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: flex-start;

  >.item {
    flex-basis: 33%;
    max-width: 33%;
    margin: 4px 0;
    box-sizing: border-box;
    line-height: 30px;

  }
}
.el-section+.el-section {
      border-top: 1px dotted #d9e1e9;
      padding-top: 20px;
      margin-bottom: 20px;
  }
.el-section-content{
  padding: 20px 12px 10px;
}
// @import "./BandWidthDetail.scss";
</style>



// WEBPACK FOOTER //
// src/components/bandWidthDetail/BandWidthDetail.vue